export const FOLLOW_UP_COMPLAINS_TRANSLATE = {
    followUpComplaints: {
        title: "Enter the protocol number to track your complaint",
        form: {
            fields: {
                protocol: {
                    label: "Protocol Number",
                    placeholder: "Enter the protocol number here"
                }
            }
        }
    }
}
